<div [ngClass]="{overlay: modals.length || dialogs.length || notices.length || loading, loading: loading && !modals.length}" (mousedown)="overlayClicked()">

	<div *ngFor="let modal of modals" class="modal-container" [class.rb-theme]="modal.component.theme === 'rb'">

		<bb-modal [icon]="modal.icon" [title]="modal.title" [showCloseButton]="modal.component.name !== 'bb-about'" [ngSwitch]="modal.component.name"
			[class]="modal?.component?.class" [class.dark-theme]="modal?.component?.theme === 'dark-theme'" [class.subtitle-theme]="modal?.component?.theme === 'subtitle-theme'"
			[class.rb-theme]="modal.component.theme === 'rb'" (onClose)="onModalClose(modal)" (mousedown)="$event.stopPropagation()">
			
			<embed-preview *ngSwitchCase="'embed-preview'" class="contents"
				[inModal]="true"
				[mediaclip]="modal.component.inputs.mediaclip"
				[configuration]="modal.component.inputs.configuration"
				[assetId]="modal.component.inputs.assetId"
				[project]="modal.component.inputs.project"
				[playlist]="modal.component.inputs.playlist">
				<div class="custom-warning" *ngIf="modal.component.inputs.project">
					<span *ngIf="modal.component.inputs.project?.status === 'draft'" class="message warning">
						<i class="fa fa-warning" ></i>&nbsp;{{ 'HELP.PROJECT_NOT_PUBLISHED' | translate }}.
					</span>
				</div>
			</embed-preview>

			<embed-preview *ngSwitchCase="'playlist-preview'" class="contents"
				[showEmbedTag]="false"
				[inModal]="true"
				[mediaclip]="modal.component.inputs.mediaclip"
				[project]="modal.component.inputs.project"
				[configuration]="modal.component.inputs.configuration"
				>
			</embed-preview>
			
			<stats-progress *ngSwitchCase="'stats-progress'" class="contents"
				[clipId]="modal.component.inputs.clipId"
				[hideViews]="modal.component.inputs.hideViews"
				[parentEntityType]="modal.component.inputs.parentEntityType"
				[parentEntityId]="modal.component.inputs.parentEntityId"
				[configuration]="modal.component.inputs.configuration"
				mode="in-modal"
				(mediaclipChanged)="setTitle($event.title, modal)"
				(navigationOccurred)="removeModal(modal)"
			></stats-progress>

			<bb-about *ngSwitchCase="'bb-about'" class="contents">
				<a class="button" (click)="removeModal(modal)">{{ "CLOSE" | translate }}</a>
			</bb-about>

			<!-- The about on the login page has a bit different styling + button (aligned left instead of center) -->
			<div class="contents" *ngSwitchCase="'bb-about-rb'">
				<bb-about theme="rb"></bb-about>
				<bb-button theme="rb" backgroundColor="blue" size="big" class="button-right" (click)="removeModal(modal)">
					{{ 'CLOSE' | translate }}
				</bb-button>
			</div>

			<bb-technical-info *ngSwitchCase="'bb-technical-info'" class="contents"
				[technicalInfo]="modal.component.inputs.technicalInfo">
					<a class="button" (click)="removeModal(modal)">{{ "CLOSE" | translate }}</a>
			</bb-technical-info>

			<div class="contents" *ngSwitchCase="'custom-content'">
				<ng-container *ngTemplateOutlet="modal.component.templateRef"></ng-container>
				<bb-button *ngIf="modal.component.theme === 'rb'" theme="rb" backgroundColor="blue" size="big" class="button-right" (click)="removeModal(modal)">
					{{ 'CLOSE' | translate }}
				</bb-button>
			</div>
			
		</bb-modal>

	</div>

	<div *ngFor="let dialog of dialogs" class="dialog-container">
		<bb-dialog [icon]="dialog.icon" [title]="dialog.title" [contents]="dialog.contents" [templateRef]="dialog.templateRef" [showSave]="dialog.showSave"
		(onCancel)="dialog.onCancel()" (onConfirm)="dialog.onConfirm()" (onSaveAndClose)="dialog.onSaveAndClose()"></bb-dialog>
	</div>

	<div *ngFor="let notice of notices" class="dialog-container">
		<bb-notice [icon]="notice.icon" [type]="notice.type" [contents]="notice.contents" [title]="notice.title" [showCopy]="notice.showCopy" (onConfirm)="notice.onConfirm()" (onCopy)="notice.onCopy()"></bb-notice>
	</div>

	<bb-loading [hidden]="!loading"></bb-loading>
</div>

<div *ngFor="let toast of toasts">
	<bb-toast [icon]="toast.icon" [message]="toast.message" (toastCompleted)="removeToast(toast)"></bb-toast>
</div>
